(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResultController', ResultController);

    ResultController.$inject = ['$rootScope', '$scope', '$routeParams', '$location'];
    function ResultController($rootScope, $scope, $routeParams, $location) {

        $scope.model = {};
        initController();

        function initController() {
            var result = $routeParams;
            
            for (var i in result)
                $scope.model[i] = result[i];

            if (!$scope.model['x-order-reference'] || !$scope.model['currency'] || !$scope.model.amount)
                $location.path('/');
        }
    }
})();
